import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { WSProvider } from './context/WSContext';
import { LightboxProvider } from './context/LightboxContext';
import { E2EProvider } from './context/E2EContext';
import E2EUnlockModal from './components/E2EUnlockModal';
import { Toaster } from './components/ui/sonner';
import Login from './pages/Login';
import Home from './pages/Home';
import Chat from './pages/Chat';
import GuidaDownload from './pages/GuidaDownload';
import LeMieApp from './pages/LeMieApp';
import Informazioni from './pages/Informazioni';
import Impostazioni from './pages/Impostazioni';
import Admin from './pages/Admin';
import AdminChat from './pages/AdminChat';
import ForcePasswordChange from './pages/ForcePasswordChange';
import Novita from './pages/Novita';
import NovitaList from './pages/NovitaList';
import NovitaDetail from './pages/NovitaDetail';
import Comunicazioni from './pages/Comunicazioni';
import Preferiti from './pages/Preferiti';
import TmdbDetail from './pages/TmdbDetail';
import ConsigliOggi from './pages/ConsigliOggi';
import PWAInstall from './components/PWAInstall';
import SplashScreen from './components/SplashScreen';
import './App.css';

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-white/60">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/home" replace />;
  if (adminOnly && user.must_change_password) return <Navigate to="/force-password-change" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to={user.is_admin ? '/admin' : '/home'} replace /> : <Login />} />
      <Route path="/home" element={<Protected><Home /></Protected>} />
      <Route path="/consigli-oggi" element={<Protected><ConsigliOggi /></Protected>} />
      <Route path="/tmdb/:media/:id" element={<Protected><TmdbDetail /></Protected>} />
      <Route path="/chat" element={<Protected><Chat /></Protected>} />
      <Route path="/guida" element={<Protected><GuidaDownload /></Protected>} />
      <Route path="/apps" element={<Protected><LeMieApp /></Protected>} />
      <Route path="/info" element={<Protected><Informazioni /></Protected>} />
      <Route path="/impostazioni" element={<Protected><Impostazioni /></Protected>} />
      <Route path="/novita" element={<Protected><Novita /></Protected>} />
      <Route path="/novita/:server" element={<Protected><NovitaList /></Protected>} />
      <Route path="/novita/:server/:id" element={<Protected><NovitaDetail /></Protected>} />
      <Route path="/comunicazioni" element={<Protected><Comunicazioni /></Protected>} />
      <Route path="/preferiti" element={<Protected><Preferiti /></Protected>} />
      <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
      <Route path="/force-password-change" element={<Protected><ForcePasswordChange /></Protected>} />
      <Route path="/admin/chat/:userId" element={<Protected adminOnly><AdminChat /></Protected>} />
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default function App() {
  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);
  return (
    <div className="App grain">
      <SplashScreen />
      <BrowserRouter>
        <AuthProvider>
          <E2EProvider>
            <WSProvider>
              <LightboxProvider>
                <AppRoutes />
                <PWAInstall />
                <E2EUnlockModal />
                <Toaster theme="dark" position="top-center" richColors />
              </LightboxProvider>
            </WSProvider>
          </E2EProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
